import type { ReactNode } from 'react';
import { DotsThreeIcon } from '@phosphor-icons/react';
import { IconTooltip } from '@/components/common/IconTooltip';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

/**
 * A sidebar row's "…" menu of `children` items. Shown on hover or keyboard
 * focus of its row, and while open, laid over the row's end so names keep
 * their width.
 */
export function WorkbookRowMenu({
  label,
  disabled,
  children,
}: {
  label: string;
  disabled: boolean;
  children: ReactNode;
}) {
  return (
    <DropdownMenu>
      <IconTooltip label={label}>
        <DropdownMenuTrigger asChild>
          <Button
            size="icon"
            variant="ghost"
            className="absolute top-1/2 right-1 size-6 -translate-y-1/2 bg-background opacity-0 group-focus-within:opacity-100 group-hover:opacity-100 data-[popup-open]:opacity-100"
            disabled={disabled}
            aria-label={label}
          >
            <DotsThreeIcon className="size-3.5" />
          </Button>
        </DropdownMenuTrigger>
      </IconTooltip>
      <DropdownMenuContent align="start">{children}</DropdownMenuContent>
    </DropdownMenu>
  );
}
